module.exports = __webpack_public_path__ + "static/yello-0243e212b04193829f75059c20eaad92.png";